import React from 'react';
import { Row, Col, Card, Icon } from 'antd';
import { Bar, Pie } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { getColors } from '../../../services/graphicsService';
import { getDomain } from '../../../services/utils';
import Colors from '../../../themes/Colors';
import { resolveColor } from '../../../themes/theme';
import NoAudienceDataAlert from './NoAudienceDataAlert';

const colors = getColors(Colors.primary, getDomain(window.location.hostname));

const socioEconomicStatusData = (t, data) => ({
  labels: [
    t('Level_A'),
    t('Level_B'),
    t('Level_C'),
    t('Level_D'),
    t('Level_E'),
    t('NOT_SPECIFIED')
  ],
  datasets: [
    {
      data,
      backgroundColor: [
        colors.secondary,
        colors.secondaryLight,
        colors.primary,
        colors.primaryLight,
        colors.tertiary
      ]
    }
  ]
});

const ageData = (t, data) => ({
  labels: ['0-14', '15-19', '20-29', '30-44', '45-54', '+55', t('NOT_SPECIFIED')],
  datasets: [
    {
      label: t('Age'),
      data,
      backgroundColor: colors.primaryLight
    }
  ]
});

const genderData = (t, data) => ({
  labels: [t('Male'), t('Female'), t('Other'), t('NOT_SPECIFIED')],
  datasets: [
    {
      data,
      backgroundColor: [colors.secondary, colors.primary, colors.primaryLight, resolveColor(Colors.gray)]
    }
  ]
});

const AudienceGraphQualitativeComponent = props => {
  const { t } = useTranslation();

  const { audienceQualitative } = props;

  if (!audienceQualitative || !audienceQualitative.data) {
    return <NoAudienceDataAlert />;
  }

  const _socioEconomicStatusData = socioEconomicStatusData(t, [
    audienceQualitative.data.sec_a,
    audienceQualitative.data.sec_b,
    audienceQualitative.data.sec_c,
    audienceQualitative.data.sec_d,
    audienceQualitative.data.sec_e,
    audienceQualitative.data.sec_nc
  ]);

  const _agesData = ageData(t, [
    audienceQualitative.data.age_children,
    audienceQualitative.data.age_teens,
    audienceQualitative.data.age_young_adults,
    audienceQualitative.data.age_midlife_adults,
    audienceQualitative.data.age_mature_adults,
    audienceQualitative.data.age_seniors
  ]);

  const _genderData = genderData(t, [
    audienceQualitative.data.gender_male,
    audienceQualitative.data.gender_female,
    audienceQualitative.data.gender_other,
    audienceQualitative.data.gender_nc
  ]);

  return (
    <Row gutter={24}>
      {audienceQualitative.data.sec_nc === 100 ? null : (
        <Col span={8}>
          <Card
            title={
              <span style={{ textAlign: 'center', display: 'block' }}>
                {t('Socioeconomic level')}
              </span>
            }
            bordered={false}
          >
            {/* Chart for socioeconomic status */}
            <div style={{ height: 300 }}>
              <Pie
                data={_socioEconomicStatusData}
                options={{
                  maintainAspectRatio: false,
                  responsive: true,
                  plugins: { legend: { position: 'bottom' } }
                }}
              />
            </div>
          </Card>
        </Col>
      )}
      <Col span={audienceQualitative.data.sec_nc === 100 ? 16 : 8}>
        <Card
          title={<span style={{ textAlign: 'center', display: 'block' }}>{t('Age')}</span>}
          bordered={false}
        >
          {/* Chart for Edad */}
          <div style={{ height: 300 }}>
            <Bar
              data={_agesData}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    position: 'bottom'
                  },
                  title: {
                    display: false
                  }
                },
                scales: {
                  y: {
                    max: 100,
                    beginAtZero: true
                  }
                }
              }}
            />
          </div>
        </Card>
      </Col>
      <Col span={8}>
        <Card
          title={<span style={{ textAlign: 'center', display: 'block' }}>{t('Gender')}</span>}
          bordered={false}
        >
          {/* Chart for Género */}
          <div style={{ height: 300 }}>
            <Pie
              data={_genderData}
              options={{
                maintainAspectRatio: false,
                responsive: true,
                plugins: { legend: { position: 'bottom' } }
              }}
            />
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default AudienceGraphQualitativeComponent;
